var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3867 8C10.3867 9.32 9.32 10.3867 8 10.3867C6.68 10.3867 5.61333 9.32 5.61333 8C5.61333 6.68 6.68 5.61333 8 5.61333C9.32 5.61333 10.3867 6.68 10.3867 8Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 13.5133C10.3533 13.5133 12.5467 12.1267 14.0733 9.72667C14.6733 8.78667 14.6733 7.20667 14.0733 6.26667C12.5467 3.86667 10.3533 2.48 8 2.48C5.64667 2.48 3.45333 3.86667 1.92667 6.26667C1.32667 7.20667 1.32667 8.78667 1.92667 9.72667C3.45333 12.1267 5.64667 13.5133 8 13.5133Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0,
    d: "M0.5 15.5L0.5 0.5L15.5 0.5L15.5 15.5L0.5 15.5Z",
    stroke: "#1E5AD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dfced61dbffb6fe46feeeb5e3f941c92.svg";
export { ForwardRef as ReactComponent };